// Lecture des erreurs renvoyées par l'API : { code, message } pour les erreurs métier,
// { error, code, message, status } pour les refus de sécurité.

/** Code stable d'une erreur API (VALIDATION_FAILED, STALE_VERSION...) ; null sans réponse du serveur. */
export function apiErrorCode(error) {
    const data = error?.response?.data;
    if (!data || typeof data !== "object") return null;
    return data.code ?? data.error ?? null;
}

export function hasApiErrorCode(error, code) {
    return apiErrorCode(error) === code;
}

/** Message lisible renvoyé par le serveur, ou {@code fallback} quand il n'y en a pas. */
export function apiErrorMessage(error, fallback) {
    const message = error?.response?.data?.message;
    return typeof message === "string" && message ? message : fallback;
}
